import router from '../services/router_service';
import searchController from '../controllers/search_controller';

router.on('route:search', searchController);
